
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcToggleButtonVerticalOption as ObcToggleButtonVerticalOptionElement} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-vertical-option/toggle-button-vertical-option.js';
 
 
 

 
 export const ObcToggleButtonVerticalOption = createComponent({
   react: React,
   tagName: 'obc-toggle-button-vertical-option',
   elementClass: ObcToggleButtonVerticalOptionElement,
   events: {
     
     onSelected: 'selected' as EventName<CustomEvent<{value: string}>>,
   }
  });
 
 